export default {
  500: '服务器错误,错误状态码为:500',
  400: '错误请求(状态码:400)',
  401: '未授权,请重新登录(状态码:401)',
  403: '拒绝访问(状态码:401)',
  404: '请求错误未找到该资源(状态码:404)',
  405: '请求方法未允许(状态码:405)',
  408: '请求超时(状态码:408)'
}
